module.exports = __webpack_public_path__ + "fonts/5ccd9e32dfe8a15b677b59e1fbee134f.svg";